module.exports = __webpack_public_path__ + "img/pr-2.998d5561.png";